import store from "@plugins/store";
import {
  ATTEMPTABLE_TYPE,
  RESOURCE_ATTEMPT_TYPE,
  ATTEMPT_TYPE,
  NAMESPACE,
  ERROR_CODE,
} from "./attempt.constant";
import httpClient from "@plugins/http";
import attemptUtils from "@modules/attempt/service/attempt.utils";
import { redirect } from "@plugins/router";

const attemptRequestTransformer = (data) => {
  const attemptContext = store.state.attempt.attemptContext;
  data.attemptType = attemptContext.attemptType;
  data.attemptableType = attemptContext.attemptableType;
  data.attemptableUuid = attemptContext.attemptableUuid;

  // check attemptableType if contain assignment then assignment else lesson
  data.resourceAttemptType =
    attemptContext.attemptableType === ATTEMPTABLE_TYPE.ASSIGNMENT_LESSON
      ? RESOURCE_ATTEMPT_TYPE.ASSIGNMENT
      : RESOURCE_ATTEMPT_TYPE.LESSON;
  // check attemptType if attempt then false else ??
  data.fromCcpm = attemptContext.attemptType !== ATTEMPT_TYPE.ATTEMPT;
  return data;
};

const setupAttemptResponseInterceptor = () => {
  return httpClient.interceptors.response.use((response) => attemptResponseInterceptor(response));
};

// TODO: check for ways to standardize error handling with assignment.error.mixin,
// custom response header to specify custom handling?
/*
  This is used to intercept all responses from the attempt module for a generic handling of the response.
  Currently no customisation is available when using this, hence implementations here must apply for all cases.
  
  If customisation is needed, please use assignment.error.mixin.
*/
const attemptResponseInterceptor = (response) => {
  if (response.code === "ok") {
    return response;
  }

  const errorCode = response.errorMap && response.errorMap[0] ? response.errorMap[0] : "";
  if (errorCode === ERROR_CODE.ASSIGNMENT_PAUSED) {
    attemptUtils.showAssignmentPausedErrorModal().then(() => {
      store.dispatch(`${NAMESPACE.APP}/clearPageDirty`);
      redirect(window.location.href);
    });
  }

  return response;
};

const ejectAttemptResponseInterceptor = (interceptor) => {
  httpClient.interceptors.response.eject(interceptor);
};

const getAttemptContext = () => {
  return store.state.attempt.attemptContext;
};

export {
  attemptRequestTransformer,
  setupAttemptResponseInterceptor,
  ejectAttemptResponseInterceptor,
  getAttemptContext,
};
